import PropTypes from 'prop-types';
import React from 'react';

function ToothySad({ height, width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 379.4 415.93"
      height={height}
      width={width}
      role="presentation"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="#efece1"
            d="M188.56,288.22c46.51,0,24.89,127.71,60.26,127.71,79.24-2,73.65-133.29,93-164.38,25.13-40.38,68.57-184.46,3.28-231.18-61.57-44-123.12,0-156.4,0s-97-45.83-156.4,0c-59.92,46.27-23,191.52,3.28,231.18,20.2,30.55,13.76,162.41,93,164.38,35.37,0,13.75-127.71,60.25-127.71"
          />
          <path
            fill="#fff"
            d="M68.4,17.16C20.14,34.49,9.71,134.8,64.61,199.83c56.75,67.22,194,63.29,251.89,5.67,36.31-36.17,61-144.26-3-179.45-52.19-28.67-79.46,7.86-124,7S118.38-.78,68.4,17.16Z"
          />
          <path
            fill="#fff"
            d="M114.07,301.11c-38.55,0-10.54,75.25,9.51,74.3S143.3,301.11,114.07,301.11Z"
          />
          <path
            fill="#fff"
            d="M263.69,309.83c32.05,0,20.08,70.77-9.61,70.74C238.27,380.55,240.1,309.84,263.69,309.83Z"
          />
          <path
            fill="#ffc0d7"
            d="M128.23,170.75c0,11.11-11.67,20.13-26.07,20.13s-26.07-9-26.07-20.13,11.67-20.12,26.07-20.12S128.23,159.64,128.23,170.75Z"
          />
          <path
            fill="#ffc0d7"
            d="M301.09,170.75c0,11.11-11.67,20.13-26.07,20.13s-26.07-9-26.07-20.13,11.67-20.12,26.07-20.12S301.09,159.64,301.09,170.75Z"
          />
          <path
            fill="#541300"
            d="M116,85.58C75.3,88.2,86.33,148,119,146.93S156.63,83,116,85.58Z"
          />
          <path
            fill="#fff"
            d="M130.08,113.73c-8.65-.76-11.4,15.58-1.6,17.1S142.37,114.82,130.08,113.73Z"
          />
          <path
            fill="#541300"
            d="M263.32,85.58C304,88.2,293,148,260.27,146.93S222.65,83,263.32,85.58Z"
          />
          <path
            fill="#fff"
            d="M249.2,113.73c8.66-.76,11.4,15.58,1.6,17.1S236.92,114.82,249.2,113.73Z"
          />
          <path
            fill="#541300"
            d="M152.59,183c-6.64,9.36,3,16.59,9.27,7.89,12.14-16.72,44.85-15.33,57.17,0,6.69,8.33,15.29,2,9.27-7.89C214.15,159.76,171.05,157,152.59,183Z"
          />
        </g>
      </g>
    </svg>
  );
}

ToothySad.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};

export default ToothySad;
